export const environment = {
  environment: 'production',
  apiUrl: 'https://api.functionalacademics.com',
  appUrl: 'https://app.functionalacademics.com',
  amplitudeApiKey: 'a0a73e2c87df6359cbf3139379a3a344',
}
